import React, { useState } from "react";
import Layout from "@/components/Layout";
import { GlassCard } from "@/components/ui/glass-card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { toast } from "sonner";
import emailjs from "@emailjs/browser";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await emailjs.send(
        "service_9n5ycfi",     // replace with real service ID
        "template_80nyp5i",    // replace with real template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          message: formData.message,
          time: new Date().toLocaleString(),  // ✅ added here
        },
        "bdlE8QuapPc-plsNM"      // replace with real public key
      );
      toast.success("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      toast.error("Failed to send message. Try again.");
      console.error(error);
    }

    setLoading(false);
  };

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl text-blue-100">
            We're here to help and answer any questions
          </p>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12">

          {/* LEFT SIDE */}
          <div>
            <h2 className="text-3xl font-bold text-blue-900 mb-8">
              Get in Touch
            </h2>

            <div className="space-y-6">
              <GlassCard className="flex items-start space-x-4">
                <MapPin className="w-6 h-6 text-blue-900 mt-1" />
                <div>
                  <h3 className="font-bold text-blue-900">Address</h3>
                  <p className="text-slate-600">
                    Manwani Colony, Behind Bank of India, Pithampur, Dhar (M.P.)
                  </p>
                </div>
              </GlassCard>

              <GlassCard className="flex items-start space-x-4">
                <Phone className="w-6 h-6 text-blue-900 mt-1" />
                <div>
                  <h3 className="font-bold text-blue-900">Phone</h3>
                  <p className="text-slate-600">
                    9827780604, 9755402604
                  </p>
                </div>
              </GlassCard>

              <GlassCard className="flex items-start space-x-4">
                <Mail className="w-6 h-6 text-blue-900 mt-1" />
                <div>
                  <h3 className="font-bold text-blue-900">Email</h3>
                  <p className="text-slate-600">
                    vaibhavgithub77@gmail.com
                  </p>
                </div>
              </GlassCard>
            </div>
          </div>

          {/* RIGHT SIDE FORM */}
          <div>
            <h2 className="text-3xl font-bold text-blue-900 mb-8">
              Send us a Message
            </h2>

            <GlassCard>
              <form onSubmit={handleSubmit} className="space-y-6">

                <Input
                  type="text"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />

                <Input
                  type="email"
                  placeholder="Your email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  required
                />

                <Input
                  type="tel"
                  placeholder="Your phone"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  required
                />

                <textarea
                  rows="5"
                  placeholder="Your message"
                  className="w-full px-4 py-3 border rounded-lg"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                  required
                />

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-blue-900 hover:bg-blue-800 py-6 text-lg"
                >
                  {loading ? "Sending..." : "Send Message"}
                </Button>

              </form>
            </GlassCard>
          </div>


        </div>
        {/* MAP SECTION */}
        <section className="py-20 bg-slate-100">

          <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
            Find Us on Map
          </h2>

          <div className="w-full h-[500px] shadow-xl">
            <iframe
              src="https://www.google.com/maps?q=Manwani%20Colony%20Behind%20Bank%20of%20India%20Pithampur%20Dhar%20MP&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

        </section>
      </section>
    </Layout>
  );
}